import superagent from 'superagent'
import isNil from 'lodash/isNil'

const vendorsSet = vendors => ({
  type: 'VENDORS_SET',
  payload: vendors
})

const requestVendor = (token, id) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/Vendor/Get/${id}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          resolve(res.body)
        }
      })
  })
}

export const displayVendor = (id, bool) => (dispatch, getState) => {
  const vendors = getState().vendors,
    clone = Object.assign({}, vendors)
  vendors[id].active = bool
  dispatch(vendorsSet(clone))
}

export const fetchVendor = vendorId => (dispatch, getState) => {
  const token = getState().auth.token,
    vendors = getState().vendors
  return new Promise((resolve, reject) => {
    requestVendor(token, vendorId)
      .then(res => {
        vendors[res.id] = res
        dispatch(vendorsSet(vendors))
        return resolve()
      })
  })
}

export const fetchNodeVendors = nodeId => (dispatch, getState) => {
  const token = getState().auth.token,
    vendors = Object.assign({}, getState().vendors)
  superagent
    .get(`${__API_URI__}/Vendor/GetNode/${nodeId}/?includeChildren=true`)
    .set('Authorization', `Bearer ${token}`)
    .set('Platform', 'Web')
    .set('Version', `${__version__}`)
    .end((err, res) => {
      if (err) {
        console.error('Vendor Fetch Failed: ', err)
      } else {
        res.body.forEach(vendor => {
          vendors[vendor.id] = vendor
        })
        dispatch(vendorsSet(vendors))
      }
    })
}

export const fetchVendorObjects = vendorLayer => (dispatch, getState) => {
  const token = getState().auth.token,
    vendors = getState().vendors,
    vendorId = vendorLayer.vendorId,
    vendor = vendors[vendorId]

  if (isNil(vendor)) {
    return dispatch(fetchVendor(vendorId)).then(() => { return dispatch(fetchVendorObjects(vendorLayer)) })
  }
  const typeMap = {
    1: 'tracks',
    3: 'polygons',
    4: 'lines',
    5: 'circles'
  }

  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/VendorObject/Get/${vendorId}/`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          vendor['objects'] = {
            markers: [],
            photos: [],
            polygons: [],
            lines: [],
            circles: [],
            tracks: []
          }
          dispatch(vendorsSet(vendors))
          console.error('Vendor Object Fetch Failed: ', err)
          return resolve(vendor)
        }
        const vendorObjects = {
          markers: res.body.markers,
          photos: res.body.photos,
          polygons: [],
          lines: [],
          circles: [],
          tracks: []
        }
        res.body.measurements.forEach(measure => {
          const type = typeMap[measure['measurementTypeId']]
          vendorObjects[type].push(measure)
        })
        vendor['objects'] = vendorObjects
        vendor['active'] = true
        console.log(vendors)
        resolve(vendor)
        dispatch(vendorsSet(vendors))
      })
  })
}
